var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"bg-gray-100 rounded-xl p-8"},[_vm._m(0),(_vm.start && !_vm.finished)?_c('div',[_c('div',{},[_c('h1',{staticClass:"p-5 text-xl"},[_vm._v("Lucky numbers")]),_c('ul',{staticClass:" flex justify-center",attrs:{"id":"luckyNum"}},_vm._l((5),function(luckyNum){return _c('li',{key:luckyNum,class:[
            'm-5',
            'w-14',
            'h-14',
            'text-2xl',
            'pt-3',
            'text-center',
            'border-2',
            'border-black' ]})}),0)]),_c('div',{},[_c('h1',{staticClass:"pt-10 text-xl"},[_vm._v("My numbers")]),_c('ul',{staticClass:" flex justify-center",attrs:{"id":"myNum"}},_vm._l((_vm.getNumbers),function(number){return _c('li',{key:number.id,class:[
            'm-5',
            'w-14',
            'h-14',
            'text-2xl',
            'pt-3',
            'text-center',
            'border-2',
            'border-black' ]},[_vm._v(" "+_vm._s(number.value)+" ")])}),0)])]):(!_vm.start && _vm.finished)?_c('div',[_c('draw-results',{attrs:{"winningNumbers":this.winningNumbers},on:{"save":_vm.saveGame}})],1):_c('div',[_c('h1',{staticClass:"pt-10 text-xl"},[_vm._v("Play from home")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fa-3x font-bold"},[_c('i',{staticClass:"fas fa-hand-holding-usd"}),_vm._v(" Casino live Draw ")])}]

export { render, staticRenderFns }